<div [@fadeInOut]="animationState" class="tour-bubble" [ngClass]="arrowPosition">
    <div class="tour-bubble-header">
        <h3>{{ step.title }}</h3>
        <p-button size="small" [variant]="'text'" severity="contrast" title="Close Walkthrough" class="tour-bubble-close" (click)="closeTourBubble()">
            <i class="fa-solid fa-xmark"></i>
        </p-button>
    </div>

    <div class="tour-bubble-content">{{ step.content }}</div>
    <div class="tour-bubble-actions" *ngIf="step.canSkip === true">
        <button pButton size="small" title="Next Step" (click)="nextStep()">
            {{ 'next'|translation }}
        </button>
    </div>
    <div class="offset-direction offset-right">
        <i class="fa-solid fa-chevrons-left"></i>
    </div>
    <div class="offset-direction offset-left">
        <i class="fa-solid fa-chevrons-right"></i>
    </div>
    <div class="offset-direction offset-top">
        <i class="fa-solid fa-chevrons-down"></i>
    </div>
    <div class="offset-direction offset-bottom">
        <i class="fa-solid fa-chevrons-up"></i>
    </div>
</div>

